import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-confirm-dialog',
  standalone: true,
  imports: [MatIconModule, MatDialogModule, MatButtonModule],
  template: `
    <div
      mat-dialog-title
      class="d-flex my-2 align-items-center justify-content-between"
    >
      <h5 class="me-auto mb-0">{{ data.title }}</h5>

      <button
        mat-icon-button
        mat-dialog-close
        tabindex="-1"
        class="text-muted"
        disableRipple="true"
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
    <mat-dialog-content class="row justify-content-center mt-4 pb-0 pt-3">
      <p>{{ data.message }}</p>
    </mat-dialog-content>

    <mat-dialog-actions class="justify-content-evenly">
      <button
        mat-button
        class="button-outline-primary m-2"
        color="default"
        mat-dialog-close
        tabindex="-1"
      >
        {{ data.cancelText }}
      </button>
      <button
        mat-button
        class="button-raised-primary text-white"
        mat-raised-button
        color="accent"
        (click)="confirm()"
      >
        {{ data.confirmText }}
      </button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      cancelText: string;
      confirmText: string;
      message: string;
      title: string;
    }
  ) {}

  confirm() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }
}
